import { getLinks, AcceptedLinksStarts } from '@cinch-nx/data-storyblok'
import { GetStaticPathsResult } from 'next'
import {
  AcceptedArticleSlugTypes,
  genericArticleStaticPaths,
} from './data/articles-data'

export const getStaticPathsGenerator =
  (slug: string) => async (): Promise<GetStaticPathsResult> => {
    try {
      const links = await getLinks(slug as AcceptedLinksStarts)
      const paths = genericArticleStaticPaths({
        links,
        type: slug as AcceptedArticleSlugTypes,
      })

      return { paths, fallback: 'blocking' }
    } catch {
      return { paths: [], fallback: 'blocking' }
    }
  }
